import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import useCrypto from "../../../customHooks/crypto";
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useLocation } from "react-router-dom";
import moment from "moment";
import useLangTranslation from "../../../customHooks/languageProvider";

const DriveTo = () => {
  const location = useLocation();
  const history = useHistory();
  const { decryptRequest } = useCrypto();
  const MAP_KEY = decryptRequest(process.env.REACT_APP_GOOGLE_MAP_KEY);
  const { getLangTranslation } = useLangTranslation();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_KEY,
    libraries: ["places"],
  });

  const center = {
    lat:
      Number(location?.state?.data?.selectedLocation?.latitude) || 10.99835602, // Ensure lat is a valid number, fallback to 0
    lng:
      Number(location?.state?.data?.selectedLocation?.longitude) || 77.01502627, // Ensure lng is a valid number, fallback to 0
  };
  console.log("center", center);

  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  const [directionsResponse, setDirectionsResponse] = useState(null);

  /** @type React.MutableRefObject<HTMLInputElement> */
  const originRef = useRef();
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destiantionRef = useRef();

  if (!isLoaded) {
    return "Loading";
  }

  async function calculateRoute() {
    // Get current location
    const currentPosition = await getCurrentPosition();
    if (!currentPosition) {
      return;
    }
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      destination: {
        lat: currentPosition.coords.latitude,
        lng: currentPosition.coords.longitude,
      },
      origin: {
        lat: location?.state?.data?.selectedLocation?.latitude, // parent latitude
        lng: location?.state?.data?.selectedLocation?.longitude,
      },
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });

    setDirectionsResponse(results);
  }

  // Function to get current position using Geolocation API
  function getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  }

  function clearRoute() {
    setDirectionsResponse(null);
    if (originRef && originRef.current) {
      originRef.current.value = "";
    }

    if (destiantionRef && destiantionRef.current) {
      destiantionRef.current.value = "";
    }
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5"
                  >
                    <i className="icon-arrow-left" />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation("CHILD_DRIVE_TO", "Drive to")}
                  </h3>
                </div>
              </div>
            </div>
            <div
              className="d-inline-flex  align-items-center pt-cursor"
              onClick={() => history.push("/location-history")}
            >
              <span className="icon-wrap icon-blue me-2 flex-shrink-0">
                <i className="icon-history" />
              </span>
              <h6 className="mb-0">
                {getLangTranslation("LOCATION_HISTORY", "Location History")}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div style={{ width: "100%", height: "51vh" }} className="mb-6">
            <GoogleMap
              center={center}
              zoom={15}
              mapContainerStyle={{ width: "100%", height: "100%" }}
              options={{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: true,
                fullscreenControl: false,
              }}
              onLoad={(map) => setMap(map)}
            >
              <Marker position={center} />
              {directionsResponse && (
                <DirectionsRenderer directions={directionsResponse} />
              )}
            </GoogleMap>
          </div>

          {/* <div className="d-flex align-items-center mb-3">
                        <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                            <img
                                src={getImage(location?.state?.data?.kidDevice?.image) || ChildPic}
                                className='rounded-circle'
                                alt=""
                            />
                        </span>
                        <div>
                            <h5 className='d-flex align-items-center text-blue-900 mb-0'><span className='badge rounded-pill d-inline-block badge-sm bg-success me-1'></span> {location?.state?.data?.kidData?.childName}</h5>
                            <p className="mb-0 text-small ">{getLangTranslation("CONNECT_DEVICE_TITLE_2", "device")}: {location?.state?.data?.kidDevice?.Name}</p>
                        </div>
                    </div> */}
          <p className="text-dark mb-0">
            {location?.state?.data?.selectedLocation?.locationAddress}
          </p>
          <span className="text-dark">
            {moment(
              location?.state?.data?.selectedLocation?.locationTime
            ).format("DD- MMM- YYYY | hh:mm a")}
          </span>
        </div>
      </div>
    </>
  );
};

export default DriveTo;
